import axiosInstance from "apiConfig";


export const getLeadDetails = async (leadId, tenantId, userRole, userId,rmId) => {
  try {
    const response = await axiosInstance.get(`/leads/${leadId}`, {
      params: { tenantId, userRole, userId ,rmId},
    });
    // console.log("Lead Details:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching lead details:", error);
    throw error;
  };
};

export const getRmData = async (tenantId) => {
  try {
    // Use Axios to send the query parameter
    const response = await axiosInstance.get("/rm_data", {
      params: { tenant_id: tenantId }, // Correct query parameter structure
    });
    return response.data; // Return the response data
  } catch (error) {
    console.error("Error fetching RM data:", error);
    throw error; // Rethrow the error to be handled by the caller
  }
};

export const getAllLeads = async (
  tenantId,
  userId,
  userRole,
  rmId,
  startDate
) => {
  // Add startDate if provided

  const params = { tenant_id: tenantId, userId, userRole, rmId, startDate };
  // console.log("API Params for getAllLeads:", params);

  try {
    // Make the API request to fetch leads
    const response = await axiosInstance.get("/leads", { params });

    // Log and return the response for debugging
    // console.log("API Response for getAllLeads:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in getAllLeads API:", error);
    throw error; // Rethrow the error to be handled in the calling function
  }
};

export const updateLeadStatus = async (id, status_id, tenant_id) => {
  try {
    const response = await axiosInstance.put(
      "/leads/changestatus",
      { id, status_id },
      { headers: { "tenant-id": tenant_id } } // Pass tenant_id via headers
    );
    return response.data;
  } catch (error) {
    console.error("Error updating lead status:", error);
    throw error;
  }
};

export const addLeadReminder = async (reminderData, tenantId) => {
  try {
    const response = await axiosInstance.post(
      "/reminders/add-leadreminder",
      reminderData,
      {
        headers: { "tenant-id": tenantId }, // Include tenant ID in headers
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding lead reminder:", error);
    throw error;
  }
};

export const addNewLead = async (leadData) => {
  try {
    const response = await axiosInstance.post("/leads/new", leadData); // Send flat object
    return response.data;
  } catch (error) {
    console.error("Error adding new lead:", error);
    throw error;
  }
};

export const updateLeadDetails = async (id, data) => {
  try {
    // console.log("Updating lead with ID:", id, "and data:", data);
    const response = await axiosInstance.put(`/leads/${id}`, data, {
      headers: {
        "tenant-id": data.tenant_id, // Pass tenant_id as a header
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating lead:", error);
    throw error;
  }
};

export const getLeadNotes = async (leadId, tenantId) => {
  try {
    const response = await axiosInstance.get(`/lead_notes/lead/${leadId}`, {
      headers: { "tenant-id": tenantId }, // Pass tenantId as a header
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching lead notes:", error);
    throw error; // Re-throw the error for the calling component to handle
  }
};

// Add a new note for a lead
export const addLeadNote = async (noteData, tenantId) => {
  try {
    const response = await axiosInstance.post(
      "/lead_notes/add",
      { ...noteData }, // Pass the note data (lead_id, content, etc.)
      {
        headers: { "tenant-id": tenantId }, // Pass tenantId as a header
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding lead note:", error);
    throw error; // Re-throw the error for the calling component to handle
  }
};

export const updateLeadNote = async (id, payload) => {

  try {
    
    const response = await axiosInstance.put(`/lead_notes/update/${id}`, payload);
    return response.data; // Assuming the backend returns the updated note  
    
  } catch (error) {
    console.error("Error updating lead note:", error);
    throw error; // Re-throw the error for the calling component to handle
  }
};

export const deleteLeadNote = async (note_id) => {
  try {
    const response = await axiosInstance.delete(`/lead_notes/delete/${note_id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Error deleting note");
  }
};
export const addClient = async (clientData) => {
  try {
    const response = await axiosInstance.post("/clients/add", clientData);
    return response.data; // Assuming backend responds with data upon successful addition
  } catch (error) {
    throw error; // Rethrow error to handle it in the component
  }
};

export const deleteLead = async (lead_id) => {
  try {
    const response = await axiosInstance.delete(`/leads/${lead_id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Error deleting the lead");
  }
};

export const closureDetails = async (id, tenantId) => {
  try {
    const response = await axiosInstance.get(`/leads/closure-details/${id}`, {
      headers: {
        "tenant-id": tenantId, // Include tenant_id in the headers
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching closure details:", error);
    throw error.response?.data || "Failed to fetch closure details";
  }
};

// Update closure details for a lead
export const updateClosureDetails = async (closureData) => {
  try {
    // console.log("Payload being sent:", closureData);
    return await axiosInstance.put(
      `/leads/closure-details-update/${closureData.lead_id}`,
      closureData
    );
  } catch (error) {
    console.error("Error sending update request:", error);
    throw error;
  }
};
export const sendProposal = async (leadId, proposalData) => {
  try {
    const response = await axiosInstance.post(
      `/proposals/${leadId}/send-proposal`,
      proposalData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Important for file uploads
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to send proposal");
  }
};
export const fetchRmById = async (rmId) => {
  try {
    const response = await axiosInstance.get(`/rm_data/${rmId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching RM by ID:", error);
    throw error;
  }
};

export const bulkUploadLeads = async (tenantId, leadsData, rm_id) => {
  try {
    // Add the admin's rm_id to each lead (optional; not required by backend)
    const leadsWithRmId = leadsData.map((lead) => ({
      ...lead,
      rm_id, // Only if your backend handles this field
    }));

    const response = await axiosInstance.post(
      "/leads/bulk-upload",
      { leads: leadsWithRmId }, // Request body
      {
        headers: {
          "tenant-id": tenantId,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error in bulkUploadLeads:", error.response?.data || error.message);
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.message ||
        "Unknown error occurred",
    };
  }
};

export const uploadLeadFile = async (leadId, tenantId, file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("lead_id", leadId);
    formData.append("tenant_id", tenantId);

    const response = await axiosInstance.post("/fs/upload-file", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

export const fetchLeadFiles = async (leadId, tenantId) => {
  try {
    const response = await axiosInstance.get(`/fs/${leadId}`, {
      params: { tenant_id: tenantId },
    });
    // console.log(response.data);
    return response.data;
    
  } catch (error) {
    console.error("Error fetching files:", error);
    throw error;
  }
};
export const getSignedUrl = async (fileId) => {
  const response = await axiosInstance.get(`/fs/file/${fileId}/download-url`);
  return response.data.url; 
};
export const deleteLeadFile = async (fileId) => {
  try {
    const response = await axiosInstance.delete(`/fs/${fileId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting file:", error);
    throw error;
  }
}

export const getTenantStorage = async (tenantId) => {
  try {
    const response = await axiosInstance.get(`/fs/storage/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching tenant storage:", error);
    throw error;
  }
};

export const archiveLead = async (leadId, tenantId) => {
  try {
    const response = await axiosInstance.put(
      `/leads/leads/${leadId}/archive`,
      {},
      {
        headers: { "tenant-id": tenantId },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error archiving lead:", error);
    throw error;
  }
};

export const leadreminders = async (leadId, tenantId) => {
try{
  const response = await axiosInstance.get(`/reminders/reminders-by-lead/${leadId}`, {
    headers: { "tenant-id": tenantId }, // Pass tenantId as a header
  });
  return response.data;

}
catch (error) {
  console.error("Error fetching lead reminders:", error);
  throw error; // Re-throw the error for the calling component to handle
}
};

export const updateQuotationId = async (leadId, quotationId, tenantId) => {
  try {
    const response = await axiosInstance.put(`/leads/leads/${leadId}/quotation`, {
      quotation_id: quotationId,
      tenant_id: tenantId
    });
    return response.data;
  } catch (error) {
    console.error("Error updating quotation ID:", error);
    throw error;
  }
};
export const updateOpportunity = async (leadId, payload, tenantId) => {
  try {
    const response = await axiosInstance.put(`/leads/${leadId}/opportunity`, {
      ...payload,
      tenant_id: tenantId,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating opportunity ID:", error);
    throw error;
  }
};

export const getCustomFieldValues = async (leadId, tenantId) => {
  try {
    const response = await axiosInstance.get(`/custom-field-values/${leadId}`, {
      params: { tenant_id: tenantId },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching custom field values:", error);
    throw error;
  }
};

export const saveCustomFieldValues = async (leadId, tenantId, values) => {
  try {
    const response = await axiosInstance.put(`/custom-field-values/${leadId}`, {
      tenant_id: tenantId,
      values,
    });
    return response.data;
  } catch (error) {
    console.error("Error saving custom field values:", error);
    throw error;
  }
};